import { Validators } from "@angular/forms"
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants"
import { IFormKey } from "src/app/modules/shared/models/forms"
import { PrevidentialInvestmentMovement } from "../branch-switch-investment-intesa/branch-switch-investment-intesa.constants"

export const previdential_change_investment_line_form_template = {
    destinationLine: ''
}

export const previdential_change_investment_line_form_validators = {
    currentLine: [Validators.required],
    destinationLine: [Validators.required]
}

export const previdential_change_investment_line_form_keys: IFormKey[] = [
    {
        id: 'new-line-field',
        label: 'Nuovo Percorso Investimento',
        controlName: 'destinationLine',
        css: 'col-8',
        type: 'SELECT',
        options: []
    }
]

export const PREVIDENTIAL_CHANGE_INVESTMENT_LINE_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'description',
        label: 'Fondo'
    },
    {
        key: 'quoteNumber',
        label: 'Quote'
    },
        {
        key: 'fundAmount',
        label: 'Controvalore'
    },
    {
        key: 'quoteValue',
        label: 'Quotazione'
    },
    {
        key: 'quoteValueUpdateDate',
        label: 'Data Nav'
    }
]

export const PREVIDENTIAL_CHANGE_INVESTMENT_LINE_SITUATION_TABLE_KEYS: ITableKey[] = [
    {
        key: 'description',
        label: 'Fondo'
    },
    {
        key: 'subscriberAllocation',
        label: 'Iscritto (%)'
    },
        {
        key: 'companyAllocation',
        label: 'Datore di Lavoro (%)'
    },
    {
        key: 'TFRAllocation',
        label: 'TFR (%)'
    }
]

export interface FundObject {
    cCompagnia: string;
    cFondo: string;
    cTipoContributo: string;
    descrizione: string;
    dFine?: string;
    dInizio?: string; 
    nPolizza: string;
    nPosizione: string;
    pInvestimento: number;
}

export interface IChangeLineInvestmentPrevidentialRequest {
    policyNumber: string;
    newInvestmentLine: string;
    newFunds: FundObject[];
    switchFundsMovement: PrevidentialInvestmentMovement[];
}